import { co2 } from './common';

export default {
  'consumption.co2': `Viktat ${co2}-utsläpp, blanwdad körning`,
  'consumption.energy': 'Viktad strömförbrukning, blandad körning ',
  'consumption.fuel': 'Förbrukning blandad körning',
  'footnotes.local': '',
  'footnotes.wltp': `De angivna värdena har fastställts i enlighet med föreskrivet mätförfarande. Det rör sig om ”WLTP-${co2}-värdet” i den mening som avses i artikel 2, stycke 3 i Kommissionens genomförandeförordning (EU) 2017/1153. Värdena för bränsleförbrukning har beräknats utifrån dessa värden. Strömförbrukningen har fastställts utifrån förordning 683/2008/EG. Angivna värden avser inte ett enskilt fordon och är inte en del av ett erbjudande, utan tjänar enbart som jämförelse mellan de olika fordonstyperna. Samtliga utsläppsvärden gäller bil i grundversion. Högre utrustningsnivå, svensk standardutrustning, större däckdimension och högre vikt kan ge högre bränsleförbrukning och koldioxidutsläpp. Fordonsindividuella uppgifter om förbrukning och utsläpp finns på Konsumentverkets webbtjänst www.bilsvar.se Värdena varierar också beroende på eventuella tillval (extrautrustning).`,
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': `För mer information kring förbrukning och ${co2} utsläpp av nya bilar, vänligen kontakta din Mercedes-Benz agent.`,
  'search.input.label': 'Din sökterm / Onlinekod konfiguratorn',
  'search.results': 'Inga resultat funna. | {count} Sökresultat | {count} Sökresultat',
  'search.results.count': '{count} Sökresultat',
  'search.result.buy-online': 'Köp online',
  'search.results.backup': 'Inga matchande resultat. Se liknande sidor:',
  'search.results.none.summary': 'Det finns inga resultat för denna sökterm. Vänligen prova med en annan sökterm.',
  'search.show-more': 'Visa mer',
  'search.unavailable': 'Sök fungerar ej för tillfället.',
  'search.result.new': 'Ny',
  'search.result.consumption': 'Förbrukning',

  'input.placeholder': 'Din sökterm / Onlinekod konfiguratorn',

  'suggestions.all_search_results': 'Alla sökresultat',
  'suggestions.all_search_results_for': 'Visa alla resultat för',
  'suggestions.in': 'i',
  all: 'Alla',
  UCOS: 'Online Store för begagnade bilar',
  PASSENGER_CARS: 'Personbil',
  VANS: 'Transportbilar',
  NCOS: 'Online Store för nya bilar',
  VIDEO: 'Videor',
  DEALER_LOCATOR: 'Hitta din återförsäljare',
  CONFIGURATOR: 'Konfigurator',
  TEST_DRIVE: 'Provkörning',
  VEHICLE_SEARCH: 'Sök begagnad bil',
  COLLECT: 'Collection och tillbehör',
  CONNECT: 'Mercedes me Store',
  ACCESSORIES: 'Biltilbehør',

  'watch.video': 'Titta på videon',
  'input.recently': 'Nyligen sökt',
  'input.help.title': 'Vad ska du leta efter?',
  'input.help.text':
    'Sök med hjälp av fordonstyper, modeller, konfigurationskoder eller efter tillbehör, andra produkter och information.',

  'search.result.list': 'Lista',
  'search.result.grid': 'Rutnät',

  // No results found
  'support.check': 'Kontrollera om du har stavat fel eller försök igen med en annan term.',
  'support.no.results': 'Det finns inga sökresultat för denna sökterm.',
  'support.no.results.term': 'Inga resultat hittades',
  'support.chat': 'Hittar du inte det du söker? Använd vår ',
  'support.chat.with.us': 'Online-Chat-support',

  'search.results.offer': 'Populárne ponuky pre: "{query}":',
};
